"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _ReduxCheckbox = _interopRequireDefault(require("./checkbox/ReduxCheckbox"));
var _ReduxSlider = _interopRequireDefault(require("./slider/ReduxSlider"));
var _Types = require("./Types");
var _Sort = require("../../utils/Sort");
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }
  return keys;
}
function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      _defineProperty(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }
  return target;
}
function _defineProperty(obj, key, value) {
  key = _toPropertyKey(key);
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}
function _toPropertyKey(arg) {
  var key = _toPrimitive(arg, "string");
  return typeof key === "symbol" ? key : String(key);
}
function _toPrimitive(input, hint) {
  if (typeof input !== "object" || input === null) return input;
  var prim = input[Symbol.toPrimitive];
  if (prim !== undefined) {
    var res = prim.call(input, hint || "default");
    if (typeof res !== "object") return res;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (hint === "string" ? String : Number)(input);
}
var FilterItems = function FilterItems(_ref) {
  var facet = _ref.facet,
    sortBy = _ref.sortBy;
  var type = facet.type,
    datafield = facet.datafield,
    section = facet.section;
  var sortFilters = (0, _Sort.sortBySection)(_objectSpread(_objectSpread({}, facet), {}, {
    sortBy: sortBy
  }));
  var filterItems = function filterItems() {
    switch (type) {
      case _Types.InputTypes.CHECKBOX:
        return sortFilters.map(function (item, index) {
          return /*#__PURE__*/_react.default.createElement(_ReduxCheckbox.default, {
            checkboxItem: _objectSpread(_objectSpread({}, item), {}, {
              index: index,
              section: section
            }),
            datafield: datafield,
            facet: facet
          });
        });
      case _Types.InputTypes.SLIDER:
        return /*#__PURE__*/_react.default.createElement(_ReduxSlider.default, {
          facet: facet
        });
      default:
        return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null);
    }
  };
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, filterItems());
};
var _default = FilterItems;
exports.default = _default;